import axios from 'axios'
import { notification } from 'ant-design-vue'

const instance = axios.create({
  baseURL: 'http://47.102.87.223:9999',
  timeout: 30000
})

instance.interceptors.response.use(response => {
  return response.data
}, error => {
  notification.error({
    message: '网络异常, 请求超时',
    description: error
  })
  return Promise.reject(error)
})

export default instance
